import React, { useRef, useState,useEffect } from 'react'
import { Container } from '@material-ui/core';
import { validateDownload, downloadResourceUpdate, resetData } from '../../actions/DigitalDownload';
import CombineInput from './CombineInput';
import { connect } from 'react-redux';
import ValidDownload from './ValidDownload';
import ErrorInDownload from './ErrorInDownload';
import DownloadStarted from './DownloadStarted';
const DigitalDownload = ({ loading, updateDownloadLimit,validate, error, downloadingStarted, reset,
        accessCode, status, message, downloadLeft, downloadLimit, fileName, resourceTitle, filePath, fileSize}) => {
    // const {loading, error} = this.props;

    const [inputVal, setInputVal] = useState("")
    const textInputRef = useRef(); 
    useEffect(() => {
        if(error === "" && status === ""){
           setInputVal("")
           textInputRef.current && textInputRef.current.reset()
        }
        return () => {
            // cleanup
        };
    }, [error, status])
    const onValidate = (evt) =>{
        evt.preventDefault();
        validate(inputVal);
    }
    const downloadLimitUpdate = (accessCode) => {
        updateDownloadLimit({accessCode, resourceTitle})
    }
    const updateInputVal = (val)=>{
        val = val === "--"? "":val
        setInputVal(val)
    }
    const isInputEmpty = inputVal ? "":"disabled"
    const errorIconClass = (error) ? (error === "152" ? "icon-download-digital-fail" : "icon-download-digital-try-again"):"hide" 
    console.log(resourceTitle);
    return (
        <div className="digital-download-container clearfix">
            <div className="nav-breadcrumbs-outer">
                <Container>
                    <div className="nav-breadcrumbs clearfix">
                        <nav className="breadcrumbs">
                            <a href="#/">Home</a><span className="arrow-breadcrumb">&gt;</span><a href="#/digitaldownload">Digital Downloads</a>
                        </nav><h1>Digital Downloads</h1></div>
                </Container>
            </div>
            { downloadingStarted ? <DownloadStarted resourceTitle={resourceTitle} reset={reset}/>:
            <Container className="digital-center-content">
                <p>Enter your Access Code below to gain access to your digital resources.</p>
                <label>Enter Access Code</label>
                <div className="digital-text-fields-outer"> 
                    <CombineInput setInputVal={updateInputVal} onValidate={onValidate} ref={textInputRef} error={error} status={status}/>
                    {status !== "" ? <span className="icon-download-digital icon-download-digital-success"></span> : ""}
                    {error !== "" ? <span className={"icon-download-digital " + errorIconClass }>
                    <a href="javascript:void" onClick={reset}>Try Again</a></span> : ""}
                </div>

                {!loading && !error && !status ? <button className={isInputEmpty} type="button" onClick={onValidate}>Validate</button>: ""}
                {status ? <ValidDownload accessCode={accessCode} downloadLimitUpdate={downloadLimitUpdate} downloadLeft={downloadLeft} downloadLimit={downloadLimit} fileName={fileName} resourceTitle={resourceTitle} filePath={filePath} fileSize={fileSize}/> : ""}
                {error !== "" ? <ErrorInDownload errorMsg={message}/> : ""}
            </Container>
            }
        </div>

    )
}

const mapStateToProps = (state, ownProps) => {
    const { Download } = state;
    return { ...Download }
}

const mapDispatchToProps = (dispatch) => {
    return {
        validate: (payload) => { dispatch(validateDownload(payload)) },
        updateDownloadLimit: (resourceObj) => { dispatch(downloadResourceUpdate(resourceObj)) },
        reset: () => { dispatch(resetData()) },
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(DigitalDownload)
